import {
  BeforeYouStartTemplate,
  BodyContentProps,
  ContentBody,
} from '@templates';
import { useNavigate } from 'react-router-dom';
import { CallToActionCardProps } from '@molecules/CallToActionCard/CallToActionCard';
import { InformationBox } from '@molecules/InformationBox/InformationBox';
import { v4 as uuidv4 } from 'uuid';
import { RoutesList } from '@abvehicles/routes/Routes';
import { useAbVehiclesStore } from '@abvehicles/store/store';
import { beforeYouStartContent } from '@abvehicles/constants/questionData';
import { useEffect } from 'react';

const BeforeYouStartContent = ({
  bodyContent,
}: {
  bodyContent: BodyContentProps['content'];
}) => {
  return (
    <div className="flex flex-col gap-8">
      <ContentBody content={bodyContent} />
      <InformationBox
        infoText={`We can only action on reports where our officers find clear evidence that the vehicle is abandoned.`}
        variant="info"
        title=""
        data-testid="info-box"
      />
    </div>
  );
};

export const BeforeYouStartPage = () => {
  const navigate = useNavigate();
  const {
    updateSessionId,
    resetIssueDetails,
    resetYourDetails,
    updateCaseReferenceId,
    updateWantConfirmationEmail,
  } = useAbVehiclesStore();
  const contentTitle = `Report an abandoned vehicle`;
  const sessionId = uuidv4();
  const initiateForm = () => {
    updateSessionId(sessionId);
    navigate(RoutesList.INVOLVED_IN_ACCIDENT);
  };

  const reportItCTA: CallToActionCardProps = {
    linkText: 'Start now',
    onClick: initiateForm,
  };
  const callToActionCards = [reportItCTA];
  const {
    reportsAccepted,
    needToKnowItems,
    helpfulToInclude,
    linkObjectArrays,
  } = beforeYouStartContent;
  const bodyContent = [reportsAccepted, needToKnowItems, helpfulToInclude];

  useEffect(() => {
    resetIssueDetails();
    resetYourDetails();
    updateCaseReferenceId('');
    updateWantConfirmationEmail(null);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <BeforeYouStartTemplate
      contentTitle={contentTitle}
      contentSubtext={<BeforeYouStartContent bodyContent={bodyContent} />}
      callToActionCards={callToActionCards}
      linkObjectArrays={linkObjectArrays}
    />
  );
};
